/**
* reducers for the transaction
*
* Created by Tom on 19/06/18
*/
import moment from 'moment'

import C from '../constants'

const initState = {
    tLoading: false,
    tStartDate: moment(), // date of now
    tEndDate: moment().add(6, 'months'), // date of now plus 6 months
    tFetchSuccess: true,
    tData: [],
    tClosingBalance: 0
}

export const transactionState = (state = initState, action) => {

    switch(action.type) {

        // in case of `tLoading` change
        case C.SET_TRANSACTION_LOADER:
            return {
                ...state,
                tLoading: action.payload
            }

        // in case of `tStartDate` change
        case C.SET_TRANSACTION_START_DATE:
            return {
                ...state,
                tStartDate: action.payload
            }

        // in case of `tEndDate` change
        case C.SET_TRANSACTION_END_DATE:
            return {
                ...state,
                tEndDate: action.payload
            }

        // in case of `tFetchSuccess` change
        case C.SET_TRANSACTION_FETCH_SUCCESS:
            return {
                ...state,
                tFetchSuccess: action.payload
            }

        // in case of `tData` change
        case C.SET_TRANSACTION_DATA:
            return {
                ...state,
                tData: action.payload
            }

        // in case of `tClosingBalance` change
        case C.SET_TRANSACTION_CLOSING_BALANCE:
            return {
                ...state,
                tClosingBalance: action.payload
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/transactionReducers.js